(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-media-trio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vertical-media-trio')) {
    class VerticalMediaTrio extends HTMLElement {
      #mobileQuery = window.matchMedia('(max-width: 749px)');
      #reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      #controller = null;
      #frame = 0;
      #settleTimer = 0;
      #autoplayTimer = 0;
      #autoplayDeadline = 0;
      #autoplayRemaining = 0;
      #scrolledSincePause = false;
      #inView = false;
      #interacting = false;
      /** @type {IntersectionObserver | null} */
      #observer = null;
      /** @type {HTMLElement[]} */
      #clones = [];

      connectedCallback() {
        this.#controller = new AbortController();
        const { signal } = this.#controller;

        const init = () => {
          this.#setupLoop();
          this.centerMiddle();
          this.#startAutoplay();
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init, { once: true, signal });
        } else {
          init();
        }

        const track = this.track;
        const supportsScrollEnd = 'onscrollend' in window;

        track?.addEventListener(
          'scroll',
          () => {
            this.#queueSync();
            this.#scrolledSincePause = true;
            if (!supportsScrollEnd) {
              clearTimeout(this.#settleTimer);
              this.#settleTimer = setTimeout(() => this.#onSettle(), 150);
            }
          },
          { passive: true, signal }
        );

        if (supportsScrollEnd) {
          track?.addEventListener('scrollend', () => this.#onSettle(), { signal });
        }

        this.#mobileQuery.addEventListener(
          'change',
          () => {
            if (this.#mobileQuery.matches) {
              this.#setupLoop();
              this.centerMiddle();
              this.#startAutoplay();
            } else {
              this.#stopAutoplay();
              this.#teardownLoop();
            }
          },
          { signal }
        );

        if (this.autoplayDelay) {
          const pause = () => {
            this.#interacting = true;
            this.#pauseAutoplay();
          };
          const resume = () => {
            this.#interacting = false;
            this.#startAutoplay(!this.#scrolledSincePause);
          };

          // Touch events rather than pointer events: pointercancel fires as soon as a swipe starts panning.
          this.addEventListener('touchstart', pause, { passive: true, signal });
          this.addEventListener('touchend', resume, { passive: true, signal });
          this.addEventListener('touchcancel', resume, { passive: true, signal });
          this.addEventListener('focusin', (event) => {
            if (event.target instanceof Element && event.target.matches(':focus-visible')) pause();
          }, { signal });
          this.addEventListener('focusout', (event) => {
            if (!(event.relatedTarget instanceof Node) || !this.contains(event.relatedTarget)) resume();
          }, { signal });
          document.addEventListener('visibilitychange', () => this.#startAutoplay(), { signal });
          this.#reducedMotionQuery.addEventListener('change', () => this.#startAutoplay(), { signal });

          this.#observer = new IntersectionObserver(
            ([entry]) => {
              this.#inView = Boolean(entry?.isIntersecting);
              this.#startAutoplay();
            },
            { threshold: 0.5 }
          );
          this.#observer.observe(this);
        }

        for (const dot of this.dots) {
          dot.addEventListener(
            'click',
            () => {
              const panel = this.panels[Number(dot.dataset.mediaTrioDot)];
              if (panel) this.scrollToPanel(panel, true);
            },
            { signal }
          );
        }

        document.addEventListener(
          'shopify:block:select',
          (event) => {
            if (!(event.target instanceof HTMLElement) || !this.contains(event.target)) return;
            this.scrollToPanel(event.target);
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        cancelAnimationFrame(this.#frame);
        clearTimeout(this.#settleTimer);
        this.#stopAutoplay();
        this.#observer?.disconnect();
        this.#observer = null;
        this.#teardownLoop();
      }

      /** Milliseconds between automatic slides on mobile, or 0 when auto-slide is off. */
      get autoplayDelay() {
        const seconds = Number(this.dataset.autoplay);
        return seconds > 0 ? seconds * 1000 : 0;
      }

      get track() {
        return this.querySelector('[data-media-trio-track]');
      }

      get panels() {
        return [...this.querySelectorAll('[data-media-trio-panel]')];
      }

      get dots() {
        return [...this.querySelectorAll('[data-media-trio-dot]')];
      }

      centerMiddle() {
        if (!this.#mobileQuery.matches) return;
        const panels = this.panels;
        if (panels.length < 2) return;
        this.scrollToPanel(panels[Math.floor(panels.length / 2)]);
      }

      /**
       * @param {Element} panel
       * @param {boolean} [animate]
       */
      scrollToPanel(panel, animate = false) {
        const track = this.track;
        if (!track || !this.#mobileQuery.matches) return;
        const trackRect = track.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const delta = panelRect.left + panelRect.width / 2 - (trackRect.left + trackRect.width / 2);
        const behavior = animate && !this.#reducedMotionQuery.matches ? 'smooth' : 'instant';
        // Absolute scrollTo: relative scrollBy stops at the first snap point because of scroll-snap-stop: always.
        track.scrollTo({ left: track.scrollLeft + delta, behavior });
        if (behavior === 'instant') this.#syncDots();
      }

      #queueSync() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#syncDots());
      }

      /** Copies of the last and first panels on either end so swiping past an end can wrap around. */
      #setupLoop() {
        const track = this.track;
        const panels = this.panels;
        if (!track || !this.#mobileQuery.matches || panels.length < 2 || this.#clones.length) return;

        const last = panels.length - 1;
        const before = this.#createClone(panels[last], last);
        const after = this.#createClone(panels[0], 0);
        track.prepend(before);
        track.append(after);
        this.#clones = [before, after];
      }

      #teardownLoop() {
        for (const clone of this.#clones) clone.remove();
        this.#clones = [];
      }

      /**
       * @param {HTMLElement} panel
       * @param {number} index
       */
      #createClone(panel, index) {
        const clone = /** @type {HTMLElement} */ (panel.cloneNode(true));
        clone.removeAttribute('data-media-trio-panel');
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.dataset.mediaTrioClone = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;

        for (const video of clone.querySelectorAll('video')) {
          video.muted = true;
          video.play().catch(() => {});
        }

        return clone;
      }

      /** Returns the slide nearest the track's center and the real panel index it represents. */
      #closestSlide() {
        const track = this.track;
        if (!track) return null;
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        const panels = this.panels;
        let result = null;
        let closest = Infinity;

        for (const slide of track.children) {
          if (!(slide instanceof HTMLElement)) continue;
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < closest) {
            closest = distance;
            const cloneOf = slide.dataset.mediaTrioClone;
            result = { slide, index: cloneOf !== undefined ? Number(cloneOf) : panels.indexOf(slide) };
          }
        }

        return result;
      }

      #wrapIfOnClone() {
        const current = this.#closestSlide();
        if (!current || current.slide.dataset.mediaTrioClone === undefined) return;
        const panel = this.panels[current.index];
        if (panel) this.scrollToPanel(panel);
      }

      #onSettle() {
        this.#wrapIfOnClone();
        this.#startAutoplay();
      }

      get #canAutoplay() {
        return Boolean(
          this.autoplayDelay &&
            this.#inView &&
            !this.#interacting &&
            !document.hidden &&
            !window.Shopify?.designMode &&
            this.#mobileQuery.matches &&
            !this.#reducedMotionQuery.matches
        );
      }

      /**
       * Starts the countdown to the next slide along with the active segment's fill; every scroll settle restarts it.
       * `data-autoplay-state` drives the fill animation in CSS.
       * @param {boolean} [resume] Continue a countdown paused by touch or focus instead of starting over.
       */
      #startAutoplay(resume = false) {
        clearTimeout(this.#autoplayTimer);
        if (!this.#canAutoplay) {
          this.#stopAutoplay();
          return;
        }

        let wait = this.autoplayDelay;
        if (resume && this.dataset.autoplayState === 'paused' && this.#autoplayRemaining > 0) {
          wait = this.#autoplayRemaining;
        } else {
          // Re-adding the attribute after a reflow restarts the CSS fill animation from empty.
          delete this.dataset.autoplayState;
          void this.offsetWidth;
        }

        this.dataset.autoplayState = 'running';
        this.#autoplayDeadline = performance.now() + wait;
        this.#autoplayTimer = setTimeout(() => this.#advance(), wait);
      }

      /** Freezes the countdown and the fill where they are. */
      #pauseAutoplay() {
        if (this.dataset.autoplayState !== 'running') return;
        this.#scrolledSincePause = false;
        clearTimeout(this.#autoplayTimer);
        this.#autoplayRemaining = Math.max(0, this.#autoplayDeadline - performance.now());
        this.dataset.autoplayState = 'paused';
      }

      #stopAutoplay() {
        clearTimeout(this.#autoplayTimer);
        this.#autoplayRemaining = 0;
        delete this.dataset.autoplayState;
      }

      /** Scrolls to the slide after the centered one; landing on the trailing clone wraps to the first panel on settle. */
      #advance() {
        const current = this.#closestSlide();
        const track = this.track;
        if (!current || !track) return;
        const slides = [...track.children].filter((slide) => slide instanceof HTMLElement);
        const next = slides[slides.indexOf(current.slide) + 1];
        if (!next) return;
        // Hold the incoming segment empty while the slide scrolls in; the settle handler starts its fill.
        this.#autoplayRemaining = 0;
        this.dataset.autoplayState = 'paused';
        this.scrollToPanel(next, true);
        // Fallback in case the scroll never reports settling; a real settle restarts the timer first.
        this.#autoplayTimer = setTimeout(() => this.#onSettle(), 1500);
      }

      #syncDots() {
        const activeIndex = this.#closestSlide()?.index ?? 0;

        this.dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('vertical-media-trio', VerticalMediaTrio);
  }

  } catch(e) { console.error(e); }
})();
})();
